import { Grid, useAutocomplete } from "@pankod/refine-mui";

import AutoGeneratedInputCmp from "components/auto-generated-input/AutoGeneratedInputCmp";
import useAuth from "contexts/AuthContext";

export default function CompFields({
  register,
  control,
  errors,
  defaultLanguageRecord,
  getValues,
  setError,
  setValue,
  watch,
  disabled,
}) {
  const { autocompleteProps: typeAC } = useAutocomplete({
    resource: "price-types",
    pagination: {
      pageSize: 50,
    },
    metaData: {
      populate: "deep,2",
    },
    onSearch: (value) => [
      {
        field: "name",
        operator: "contains",
        value,
      },
    ],
  });

  //const owner = JSON.parse(localStorage.getItem("user")).id;
  const auth = useAuth();
  const owner = auth.user?.id ? auth.user?.id : "";

  const { autocompleteProps: facilityAC } = useAutocomplete({
    resource: "strutture",
    pagination: {
      pageSize: 999,
    },
    metaData: {
      fields: ["businessName", "id"],
    },
    filters: [
      {
        field: "owner.id",
        operator: "eq",
        value: owner,
      },
      { field: "gestore", operator: "eq", value: "false" },
    ],
    onSearch: (value) => [
      {
        field: "businessName",
        operator: "contains",
        value,
      },
    ],
  });

  const fields = [
    {
      label: "Nome",
      name: "name",
      required: true,
      type: "text",
      localized: true,
    },
    {
      label: "Struttura",
      name: "facility",
      accessor: "businessName",
      options: facilityAC,
      required: true,
      type: "autocomplete",
    },
    {
      label: "Descrizione",
      name: "description",
      required: false,
      type: "text",
      lines: 4,
      localized: true,
    },
    {
      label: "Prezzo",
      name: "price",
      required: true,
      type: "number",
    },
    {
      label: "Tipologia prezzo",
      name: "price_type",
      accessor: "name",
      options: typeAC,
      required: true,
      type: "autocomplete",
    },
    {
      type: "title",
      variant: "h6",
      label: "Immagine",
    },
    {
      label: "Immagine*",
      name: "image",
      required: true,
      type: "image",
    },
  ];

  return (
    <Grid container spacing={2}>
      {fields.map((field, index) => {
        return (
          <AutoGeneratedInputCmp
            key={index}
            disabled={disabled}
            {...field}
            register={register}
            control={control}
            errors={errors}
            setError={setError}
            fieldVariants="outlined"
            defaultValue={watch(field.name)}
            defaultLanguageRecord={defaultLanguageRecord}
            getValues={getValues}
            setValue={setValue}
            watch={watch}
          />
        );
      })}
    </Grid>
  );
}
